export default __webpack_public_path__ + "static/media/sd-vid-2.48dedc4e.mp4";